import { useEffect, useRef } from 'react';

/**
 * Let the ambient layer fill this page's allow-listed fields.
 * handlers.fill(fields) and handlers.search() should close over current setters.
 */
export function useVaniForm(route, handlers) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    const onFill = (e) => {
      const detail = e.detail || {};
      if (detail.route && detail.route !== route) return;
      if (detail.fields && handlersRef.current.fill) handlersRef.current.fill(detail.fields);
    };
    const onSearch = (e) => {
      const detail = e.detail || {};
      if (detail.route && detail.route !== route) return;
      if (handlersRef.current.search) handlersRef.current.search();
    };
    window.addEventListener('vani:fill_form', onFill);
    window.addEventListener('vani:run_search', onSearch);
    return () => {
      window.removeEventListener('vani:fill_form', onFill);
      window.removeEventListener('vani:run_search', onSearch);
    };
  }, [route]);
}
